'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Alert from '../../Alert';

import OTButton from '../../tag/OTButton';
import OTButtonGroup from '../../tag/OTButtonGroup';
import { HashRouter, Redirect, Route, withRouter } from 'react-router-dom';
import SessionUtils from '../../../utils/SessionUtils';
import DockBar from '../../dockbar/DockBar';
import { get, omit } from 'lodash';
import Api from '../../../api/Api';
import { connect } from 'react-redux';
import { doExitHpa } from '../../../data/hpa/actions';
import AgreementCancelModal from '../AgreementCancelModal';
import WindowUtils from '../../../utils/WindowUtils';
import Urls from '../../../definitions/Urls';
import TosCancelModal from './TosCancelModal';

const AgreementDockbar = withRouter(({ location }) => (
  <DockBar logoLink={location.pathname} />
));

const { id: module_id } = module;

class TosUpdated extends React.Component {
  constructor() {
    super();
    this.state = { agreement: '', modalIsOpen: false, error: null };
  }

  componentDidMount() {
    document.getElementById('skip-to-content').focus();
  }

  agree = (val) => {
    this.setState({ agreement: val });
  };

  showError = (event) => {
    event.preventDefault();
    this.setState({ error: true });
  };

  cancel = (event) => {
    event.preventDefault();
    this.setState({ modalIsOpen: true });
  };

  closeModal = (action) => {
    switch (action) {
      case 'abort':
        this.cancelAgreement();
        break;
      case 'cancel':
        this.setState({ modalIsOpen: false });
        break;
    }
  };

  completeAgreement = (event) => {
    //let errors = this.validateAndSetErrors(true, true, true);
    this.setState({
      sendingAgreement: true,
    });
    Api.saveUserTosAgreement({ payload: this.state.agreement })
      .then(() => {
        if (this.state.agreement === 'ACCEPT') {
          // successful - log in

          // here we practically refresh, not navigate since
          // Urls.frontPage is a hash url
          WindowUtils.refresh(Urls.frontPage);
        } else {
          this.setState({ modalIsOpen: true });
        }
      })
      .catch((err) => {
        this.setState({
          agreementError: true,
          sendingAgreement: false,
        });
      });
  };

  cancelAgreement = () => {
    /* log event to backend, and redirect to logout (logout independent of success...)
     *  also current path is sent as payload as required.
     * */
    let page = get(this, 'props.location.pathname', null);

    if (page !== null) {
      page = page.replace('/', '');
    }

    Api.updateUserAgreement({ payload: false }).then(() => {
      SessionUtils.logout();
    });
  };

  redirectAfterCancelAgreement() {
    let { isHpa, doExitHpa } = this.props;
    if (isHpa) {
      doExitHpa();
    } else {
      SessionUtils.logout();
    }
  }

  render() {
    var today = new Date();

    return (
      <div>
        <div>
          <HashRouter>
            <div>
              <div className="row-fluid">
                {/* Render basic topbar without any actions since user is not known at this phase*/}
                <AgreementDockbar />
              </div>

              <div className="row-fluid ot-maincontainer">
                <div>
                  <Route
                    path="/"
                    render={(props) => (
                      <div id="ot-mainview" className="ot-mainview span12">
                        <div className="ot-tosupdate-page">
                          <h1 className="ot-tosupdate-title">
                            <FormattedMessage
                              id={`${module_id}.title`}
                              values={{
                                br: <br />,
                              }}
                            />
                          </h1>
                          <div className="ot-tosupdate-date">
                            {today.getDate() +
                              '.' +
                              today.getMonth() +
                              '.' +
                              today.getFullYear()}
                          </div>
                          <p className="infoTitle">
                            <b>
                              <FormattedMessage id={`${module_id}.infotext1`} />
                            </b>
                          </p>
                          <div className="row-fluid infotext">
                            <div className="span6">
                              <p>
                                <FormattedMessage
                                  id={`${module_id}.infotext2`}
                                />
                              </p>
                            </div>
                            {/* Fields are not editable in any case, so we are not making these into fields*/}
                            <div className="span6 ot-tosupdate-form">
                              <div className="control-group">
                                <div className="controls">
                                  <fieldset>
                                    <div className="radio-block">
                                      <label htmlFor={'agree'}>
                                        <input
                                          type="radio"
                                          name="agree"
                                          value="agree"
                                          id="agree"
                                          checked={
                                            this.state.agreement === 'ACCEPT'
                                          }
                                          onChange={() => this.agree('ACCEPT')}
                                        />
                                        <span className="radio-check" />
                                        <span className="radio-label">
                                          <FormattedMessage
                                            id={`${module_id}.radioagree`}
                                          />
                                        </span>
                                      </label>
                                      <div style={{ paddingLeft: '30px' }}>
                                        <i className="icon-external-link" />{' '}
                                        <a href="/kayttoehdot" target="_blank">
                                          Lue käyttöehdot
                                        </a>
                                      </div>
                                    </div>
                                    <div className="radio-block">
                                      <label htmlFor={'deny'}>
                                        <input
                                          type="radio"
                                          name="deny"
                                          value="deny"
                                          id="deny"
                                          checked={
                                            this.state.agreement === 'DENY'
                                          }
                                          onChange={() => this.agree('DENY')}
                                        />
                                        <span className="radio-check" />
                                        <span className="radio-label">
                                          <FormattedMessage
                                            id={`${module_id}.radiodecline`}
                                          />
                                        </span>
                                      </label>
                                    </div>
                                  </fieldset>
                                </div>
                                <div>
                                  {this.state.error && (
                                    <Alert message="agreement.selection.error" />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="ot-tosupdate-buttons row-fluid text-center">
                            <OTButtonGroup
                              fullWidth
                              type={'big'}
                              expectedCount={2}
                            >
                              <OTButton onClick={this.cancel}>
                                <FormattedMessage id={'logout'} />
                              </OTButton>
                              <OTButton onClick={this.completeAgreement}>
                                <FormattedMessage id={'accept'} />
                              </OTButton>
                            </OTButtonGroup>
                          </div>
                        </div>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </HashRouter>
        </div>
        <TosCancelModal
          isOpen={this.state.modalIsOpen}
          closeModal={this.closeModal}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isHpa: state.hpa.isHpa,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    doExitHpa: () => dispatch(doExitHpa()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TosUpdated);
